import React from "react";
import { Component } from "react";
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
//import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';

class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        }
        
    }

    closeModal = () => {
        this.setState({ open: false });
    }  

    handleLogOutOpen = () => {
        this.setState({ open: true });
    }


    render() {
        return (
            <>  
                <Modal
                    isOpen={this.state.open}
                   // onRequestClose={this.closeModal}        
                    contentLabel="Logout Modal"
                    ariaHideApp={false}
                    backdrop="static" 
                    style={{
                        content: {
                            top: '40%',
                            left: '50%',
                            right: 'auto',  
                            bottom: 'auto',
                            backgroundColor: '#f0eee4',
                            marginRight: '-50%',
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '10px',
                            padding: '20px',
                            width: '80%',            
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            border: "1px solid darkblue",
                            fontFamily:"lora"
                        },
                    }}
                >
                    <div style={{ textAlign: "center", alignItems: "center", justifyContent: "center", height: "25vh", marginTop: "20%", borderRadius: "10px", fontSize:"18px"  }}>
                        <span style={{textAlign: "center", fontStyle: "italic", color: "darkblue", fontSize: "25px", fontWeight: "bold", textShadow: "1px 1px 2px white"}}>Logout</span>
                        <p style={{color:"darkblue"}}>Are you sure you want to logout?</p>
                        <Button style={{ margin: "15px", fontWeight: "bold", backgroundColor: "rgba(30, 104, 40, 1)", color: "white" }} onClick={this.closeModal}>Cancel</Button>
                        <Button style={{ margin: "15px", color: "white", fontWeight: "bold" }} onClick={this.props.confirmLogout} color="danger">Logout</Button>
                    </div>
                </Modal>    
            </>
        );
    }
}
export default Logout